<template>
    <div class="cc-payments" v-if="shouldPaymentsBeShown">
        <div class="cc-payments__header">
            <div class="cc-payments__title">{{ translations['Payments'] }}</div>
            <a class="cc-payments__change cc-link" v-if="isAnyPaymentSelected" @click="unsetPayment">{{ translations['Change payment'] }}</a>
        </div>
        <div class="cc-payments__main">
            <payment v-for="payment in payments" v-bind:key="payment.uniqueName" :payment="payment"/>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Payment from "./Payment";

    export default {
        components: {
            Payment,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                selectedCarrier: state => state.selectedCarrier,
                payments: state => state.payments,
                selectedPayment: state => state.selectedPayment,
            }),
            shouldPaymentsBeShown: function () {
                return this.selectedCarrier !== null && this.selectedCarrier !== '' && this.payments && this.payments.length > 0;
            },
            isAnyPaymentSelected: function () {
                return this.selectedPayment !== null && this.selectedPayment !== '';
            },
        },
        methods: {
            unsetPayment: function () {
                this.$store.dispatch('SELECT_PAYMENT', null);
            },
        },
        name: 'Payments',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/payments";
</style>
